module.exports = __webpack_public_path__ + "img/unveiling-the-power-of-llm.df3bfc78.jpg";